import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { LicenseInfo } from '@mui/x-license-pro'
import App from './App'
import OktaSSO from './authentication/OktaSSO'
import reportWebVitals from './reportWebVitals'

if (process.env.REACT_APP_MUI_KEY) {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY)
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <OktaSSO>
        <App />
      </OktaSSO>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
